// CVSS 3.1 base score, per the FIRST specification (section 7.1), for the
// review page's metric picker — the backend's cvss_calc.py computes the same.

export const METRICS = ["AV", "AC", "PR", "UI", "S", "C", "I", "A"];

const W = {
  AV: { N: 0.85, A: 0.62, L: 0.55, P: 0.2 },
  AC: { L: 0.77, H: 0.44 },
  PR_U: { N: 0.85, L: 0.62, H: 0.27 },
  PR_C: { N: 0.85, L: 0.68, H: 0.5 },
  UI: { N: 0.85, R: 0.62 },
  CIA: { H: 0.56, L: 0.22, N: 0 },
};

// Round up to one decimal, avoiding floating-point artefacts (spec Appendix A).
function roundup(x) {
  const i = Math.round(x * 100000);
  return i % 10000 === 0 ? i / 100000 : (Math.floor(i / 10000) + 1) / 10;
}

export function parseVector(vector) {
  if (!vector) return null;
  const parts = {};
  for (const seg of vector.replace(/^CVSS:3\.[01]\//i, "").split("/")) {
    const [k, v] = seg.split(":");
    if (METRICS.includes(k)) parts[k] = v;
  }
  return METRICS.every((k) => parts[k]) ? parts : null;
}

export function formatVector(m) {
  return "CVSS:3.1/" + METRICS.map((k) => `${k}:${m[k]}`).join("/");
}

export function baseScore(m) {
  if (!m) return null;
  const iss = 1 - (1 - W.CIA[m.C]) * (1 - W.CIA[m.I]) * (1 - W.CIA[m.A]);
  const changed = m.S === "C";
  const impact = changed ? 7.52 * (iss - 0.029) - 3.25 * Math.pow(iss - 0.02, 15) : 6.42 * iss;
  const expl = 8.22 * W.AV[m.AV] * W.AC[m.AC] * (changed ? W.PR_C : W.PR_U)[m.PR] * W.UI[m.UI];
  if (impact <= 0) return 0;
  return changed ? roundup(Math.min(1.08 * (impact + expl), 10)) : roundup(Math.min(impact + expl, 10));
}

export function severity(score) {
  if (score == null) return null;
  if (score === 0) return "NONE";
  if (score < 4) return "LOW";
  if (score < 7) return "MEDIUM";
  if (score < 9) return "HIGH";
  return "CRITICAL";
}
